module.exports = __webpack_public_path__ + "static/media/building_darkbleu.d45a5473.svg";